module.exports = __webpack_public_path__ + "static/gatLogo-c49ae13ed569eced794b8eb5327ff122.png";